import * as React from 'react';
import { CountdownTimer } from '@grandvisionhq/common';
import { compose } from '@grandvisionhq/utils';
import { withBreakpointVisibility } from '../../hocs/with-breakpoint-visibility.js';
import { withAnchor } from '../../hocs/with-anchor.js';

/**
 * This variant of the Rich Text component is used on content pages
 */ const CmsCountdownTimerDocument = ({ component  })=>{
    const { endDate , showCountdown , countdownText , url , layout  } = component.getParameters();
    return /*#__PURE__*/ React.createElement(CountdownTimer, {
        endDate: endDate,
        countdownText: countdownText,
        showCountdown: showCountdown,
        url: url,
        layout: layout
    });
};
var CmsCountdownTimerDocument$1 = compose(withBreakpointVisibility, withAnchor)(CmsCountdownTimerDocument);

export { CmsCountdownTimerDocument, CmsCountdownTimerDocument$1 as default };
//# sourceMappingURL=CountdownTimerDocument.js.map
